<template>
  <div class="w-100 no-gap">
    <!-- Navigation Menu -->
    <nav class="navbar-custom">
      <div class="navbar-container">
        <router-link
            v-for="(item, index) in navItems"
            :key="index"
            :to="item.route"
            class="navbar-item"
            :class="{ active: $route.path === item.route }"
        >
          <CIcon
              :name="item.iconName"
              class="navbar-icon"
              width="16"
              height="16"
          />
          {{ item.title }}
        </router-link>
      </div>
    </nav>

    <!-- Display subpage here -->
    <div class="content-area p-3">
      <router-view />
    </div>
  </div>
</template>

<script>
import '@/assets/css/slide.css'
import '@/assets/css/commit.css'
import {CIcon} from "@coreui/vue";


export default {
  name: 'committee_home',
  components: {
    CIcon
  },
  data() {
    return {
      navItems: [
        {
          title: 'APPROVE CANDIDATE',
          iconName: 'cil-description',
          route: '/committee/committee_home/Approve'
        },
        {
          title: 'EDIT CONDITION',
          iconName: 'cil-clock',
          route: '/committee/committee_home/edit_condition'
        },
        {
          title: 'TOTAL SCORE',
          iconName: 'cil-user-plus',
          route: '/committee/committee_home/score_candidate'
        },

      ]
    }
  }
}
</script>